/*

class to generate an appointment response

https://www.hl7.org/fhir/appointmentresponse.html

{
  "state" : "<code>", // R!  busy | free | busy-unavailable | busy-tentative | entered-in-error
  "userType" : "<code>", // orgAdmin || providerAP || providerLP || patient
  "userId" : "<String>"
  "scheduleId" : "<String>"
  "slotId" : "<String>"
  "appointmentId" : "<String>"
  "start" : "<instant>", // Time from appointment, or requested new start time
  "end" : "<instant>", // Time from appointment, or requested new end time
  "participantType" : [{ code }], // Role of participant in the appointment
  "actor" : { Reference(Patient|Practitioner|PractitionerRole|RelatedPerson|
   Device|HealthcareService|Location) }, // Person, Location, HealthcareService, or Device
  "participantStatus" : "<code>", // R!  accepted | declined | tentative | needs-action
  "comment" : "<string>" // Additional comments
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES, APPOINTMENT_RESPONSES } = require('@bcm/constants');
const { joiValidateObj, identifiers } = require('../datastructComponents');
const { DataTableBase } = require('./base.class');
const { codeSchema } = require('./code.class');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  userId: Joi.string().required(),
  scheduleId: Joi.string().required(),
  slotId: Joi.string().required(),
  appointmentId: Joi.string().required(),
  appointmentResponseId: Joi.string().required(),
  start: Joi.string().required(),
  end: Joi.string().required(),
  participantType: Joi.array().items( codeSchema ),
  actor: Joi.array().items( Joi.string().required() ).required(),
  participantStatus: Joi.string().valid( ...Object.keys(APPOINTMENT_RESPONSES)).optional(),
  comment: Joi.string().optional(),
};

// Define class
class AppointmentResponse extends DataTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super (
      identifiers.appointmentResponse.buildPk(obj.scheduleId),
      identifiers.appointmentResponse.buildSk(obj.state, obj.userType, obj.userId, obj.scheduleId, obj.slotId, obj.appointmentId, obj.appointmentResponseId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.AppointmentResponse = AppointmentResponse;
exports.appointmentResponseSchema = schema;